// @ts-nocheck
/* Port of ReleaseTimeline.js (45L). BYTE-IDENTICAL. */
import React from 'react';
import ReleaseCard from './ReleaseCard';
import { groupReleasesByMonth, splitDateParts } from './releaseUtils';

const ReleaseTimeline = ({ releases, cardProps }: any) => {
  const groups = groupReleasesByMonth(releases);

  return (
    <div className="rc-timeline">
      {groups.map((group: any) => (
        <section key={group.key}>
          <div className="rc-tl-month">
            <h4>{group.key}</h4>
            <span>
              {group.releases.length}{' '}
              {group.releases.length === 1 ? 'release' : 'releases'}
            </span>
          </div>

          {group.releases.map((release: any, idx: number) => {
            const parts = splitDateParts(release.release_date);
            const isLast = idx === group.releases.length - 1;
            return (
              <div className="rc-tl-row" key={release.id}>
                <div className="rc-tl-rail">
                  <div className="rc-tl-date">
                    <span className="day">{parts.day}</span>
                    <span className="mon">{parts.month}</span>
                    <span className="yr">{parts.year}</span>
                  </div>
                  {!isLast && <div className="rc-tl-line" />}
                </div>
                <div className="rc-tl-card-wrap">
                  <ReleaseCard release={release} {...cardProps} />
                </div>
              </div>
            );
          })}
        </section>
      ))}
    </div>
  );
};

export default ReleaseTimeline;
